const modalEditPhotoModalEquipServiceQuest = {
  title: 'Editar foto da pergunta'
};

export default modalEditPhotoModalEquipServiceQuest;
